import cargo from "./cargo.jpg";
import download from "./download.jpg";
import ocean from "./ocean.png";
import road from "./road.jpg";
import worldwide4 from "./worldwide4.png";

const Images = [
  cargo,
  download,
  ocean,
  road,
  worldwide4,
  cargo,
  download,
  ocean,
  road,
  worldwide4,
  cargo,
  download,
  ocean,
  road,
  worldwide4,
  cargo,
  download,
  ocean,
  road,
  worldwide4,
  cargo,
  download,
  ocean,
  road,
  worldwide4,
  cargo,
  download,
  ocean,
  road,
  worldwide4,
  cargo,
  download,
  ocean,
  road,
  worldwide4,
];

export default Images;
